import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../../pcr/store/pcr.types'
import { setEmployer } from '../../employer/store/employer.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { resetEmployerState } from '../../../patientDemographics/employer/store/employer.actions'
import { resetEmployer } from '../../store/patientDemographics.actions'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'

export function* getEmployer(pcrDoc: IPcr) {
  const employer = pcrDoc.patient?.patientDemographics?.employer
  if (employer && Object.keys(employer).length !== 0) {
    yield put(setEmployer(employer))
  } else {
    yield put(resetEmployerState())
    yield put(resetEmployer())
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getEmployer, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getEmployer.saga.ts: ${e}`))
  }
}

export function* getEmployerSaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
